import {getReservationTracker} from "../tracking/get_reservation_tracker";
import {IReservationTrackingContext} from "../tracking/track_reservation_events";
import {IReservationRequest} from "../types/IReservationRequest";

interface IReservationCloseParams {
    // null only while the host has nothing to reserve - closing is then not reported
    request: IReservationRequest | null;
    isConfirmed: boolean;
    isSubmitting: boolean;
    isCloseRequested: boolean;
    trackingContext: IReservationTrackingContext;
    // starts the exit animation of the host modal
    requestClose: () => void;
}

// The two ways out of the reservation steps, reported in the funnel of the request: a close (the close button, the overlay or Esc) and ROZUMIEM of the confirmation
export const getReservationCloseHandlers = (params: IReservationCloseParams) => {
    const {request, isConfirmed, isSubmitting, isCloseRequested, trackingContext, requestClose} = params;

    return {
        close: () => {
            // a code on its way would be lost
            if (isSubmitting || isCloseRequested) {
                return;
            }

            if (request) {
                getReservationTracker(request).close(request, isConfirmed ? "confirmed" : "code", trackingContext);
            }

            requestClose();
        },
        confirmedClose: () => {
            if (isCloseRequested) {
                return;
            }

            if (request) {
                getReservationTracker(request).confirmedClose(request, trackingContext);
            }

            requestClose();
        }
    };
};
import {getReservationTracker} from "../tracking/get_reservation_tracker";
import {IReservationTrackingContext} from "../tracking/track_reservation_events";
import {IReservationRequest} from "../types/IReservationRequest";

interface IReservationCloseParams {
    // null only while the host has nothing to reserve - closing is then not reported
    request: IReservationRequest | null;
    isConfirmed: boolean;
    isSubmitting: boolean;
    isCloseRequested: boolean;
    trackingContext: IReservationTrackingContext;
    // starts the exit animation of the host modal
    requestClose: () => void;
}

// The two ways out of the reservation steps, reported in the funnel of the request: a close (the close button, the overlay or Esc) and ROZUMIEM of the confirmation
export const getReservationCloseHandlers = (params: IReservationCloseParams) => {
    const {request, isConfirmed, isSubmitting, isCloseRequested, trackingContext, requestClose} = params;

    return {
        close: () => {
            // a code on its way would be lost
            if (isSubmitting || isCloseRequested) {
                return;
            }

            if (request) {
                getReservationTracker(request).close(request, isConfirmed ? "confirmed" : "code", trackingContext);
            }

            requestClose();
        },
        confirmedClose: () => {
            if (isCloseRequested) {
                return;
            }

            if (request) {
                getReservationTracker(request).confirmedClose(request, trackingContext);
            }

            requestClose();
        }
    };
};
